module.exports = __webpack_public_path__ + "static/img/novice_guide_teacher_bg.2549afb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/novice_guide_teacher_bg.png
// module id = 3O0O
// module chunks = 2